<template>
  <div class="dialpad-container">
    <div>
      <dialpad v-if="changeCallSubNav != 'quickconnects'"></dialpad>
      <!-- <dialer v-if="changeCallSubNav != 'quickconnects'"></dialer> -->
    </div>
    <div class="dialer-switch-container">
      <!-- DO NOT DELETE THIS ( FOR REFERENCE) -->
      <!-- <b-button
        pill
        size="sm"
        @click="changeCallSubNav('call')"
        variant="outline-secondary"
        id="tooltip-target-back"
      >
        <font-awesome-icon icon="chevron-left" size="sm" /> Back
      </b-button> -->
      <b-button
        size="sm"
        @click="handleBack()"
        variant="outline-secondary"
        id="tooltip-target-back"
      >
        <font-awesome-icon icon="chevron-left" size="sm" /> Back
      </b-button>
      <b-tooltip
        target="tooltip-target-back"
        triggers="hover"
        :noninteractive="true"
        placement="bottom"
        >Back</b-tooltip
      >

      <!-- <b-button
        size="sm"
        v-if="callSubNav == 'dialpad'"
        @click="changeCallSubNav('quickconnects')"
        id="tooltip-target-quickconnect"
        variant="secondary"
      >
        <font-awesome-icon icon="th" size="sm" /> Quick Connects
      </b-button> -->

      <b-button
        size="sm"
        v-if="callSubNav == 'quickconnects'"
        @click="changeCallSubNav('dialpad')"
        id="tooltip-target-dialpad"
        variant="secondary"
      >
        <font-awesome-icon icon="th" size="sm" /> Dial Pad
      </b-button>
      <b-tooltip
        target="tooltip-target-dialpad"
        triggers="hover"
        :noninteractive="true"
        placement="bottom"
        >Dial Pad</b-tooltip
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { makeOutboundCall, onAddConference } from "../../../lib/CallActions";
import Dialpad from "./../../Dialpad/index.vue";

import Dialer from "./../../Dialer/index.vue";

export default {
  name: "DialerSwitch",
  components: {
    Dialpad,
    Dialer,
  },
  data() {
    return {};
  },
  methods: {
    changeCallSubNav(page) {
      this.$store.dispatch("actions/callSubNavigation", page);
    },
    handleBack() {
      this.$store.dispatch("call/updateNumberPad", false);
      this.$store.dispatch("actions/callSubNavigation", 'call');
    },
    keyDial(number) {
      if ((number) => 0 && number <= 9) {
        this.$store.dispatch(
          "call/setDialedNumber",
          this.dialedNumber + number
        );
      }
    },
    async MakeOutboundCall() {
      if (this.number >= 10) {
        if (this.pageroute == "home") {
          makeOutboundCall(
            "Unknown Caller",
            this.countryCode.code + this.number
          );
          this.$store.dispatch("actions/setOutboundCall", true);
        } else {
          await onAddConference("number", this.countryCode.code + this.number);
          let confStatus = await checkThirdPartyStatus();
          if (confStatus == "success") {
            this.$store.dispatch("call/setCallType", "conference");
            this.$store.dispatch("actions/callSubNavigation", "call");
          } else {
            let postData = {};
            postData.action = "SHOW_NOTIFICATION";
            postData.type = "ERROR";
            postMessage = "Outbound call not connected";
            parent.postMessage("*", postData);
          }
        }
      }
    },
  },

  computed: {
    ...mapGetters([
      "callSubNav",
      "dialable_countries",
      "dialedNumber",
      "countryCode",
    ]),
  },
};
</script>

<style scoped>
.dialer-switch-container > button {
  margin-right: 5px;
}

.dialer-switch-container {
  /* margin-top: 15px; */
  position: absolute;
  bottom: 12px;
  float: left;
  text-align: center;
}

.dialpad-container {
  text-align: center;
  margin-top: 0px;
}

.button-row {
  margin-top: 10px;
}

.dialpad-button {
  width: 22%;
  height: 42px;
  margin-top: 2px;
  margin-right: 5px;
  margin-left: 5px;
  font-size: 1rem;
  line-height: 0.5;
  border-radius: 0.25rem;
}

.dialpad-number {
  font-size: 15px;
  font-weight: bold;
}

.dialpad-letters {
  font-size: 13px;
  color: #ccc;
}

.dialpad-filler {
  visibility: hidden;
}

/* .btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 0.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
} */
</style>
